import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'

const messages = defineMessages({
  companyRequired: {
    id: 'loyalty.newRule.form.company.required',
    defaultMessage: 'The company is required'
  },
  nameRequired: {
    id: 'loyalty.newRule.form.name.required',
    defaultMessage: 'The name is required'
  },
  nameMin: {
    id: 'loyalty.newRule.form.name.max',
    defaultMessage: 'The name should be at least 2 characters'
  },
  nameMax: {
    id: 'loyalty.newRule.form.name.max',
    defaultMessage: 'The name can be up to 100 characters'
  },
  descriptionMax: {
    id: 'loyalty.newRule.form.description.max',
    defaultMessage: 'The description can be up to 250 characters'
  },
  descriptionMin: {
    id: 'loyalty.newRule.form.description.min',
    defaultMessage: 'The description should be at least 2 characters'
  },
  typeRequired: {
    id: 'loyalty.newRule.form.details.required',
    defaultMessage: 'The type is required'
  }
})

export const schema = (intl: IntlShape): yup.AnySchema => {
  return yup.object().shape({
    company: yup.object().shape({
      id: yup.string().required(intl.formatMessage(messages.companyRequired))
    }),
    rewardName: yup
      .string()
      .required(intl.formatMessage(messages.nameRequired))
      .min(2, intl.formatMessage(messages.nameMin))
      .max(100, intl.formatMessage(messages.nameMax)),
    rewardDescription: yup
      .string()
      .min(2, intl.formatMessage(messages.descriptionMin))
      .max(250, intl.formatMessage(messages.descriptionMax)),
    rewardType: yup.string().required(intl.formatMessage(messages.typeRequired))
  })
}
